import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ViewGridIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "view-grid",
  "ViewGridIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M1.3335 1.33337H7.3335V7.33337H1.3335V1.33337ZM2.66683 2.66671V6.00004H6.00016V2.66671H2.66683ZM8.66683 1.33337H14.6668V7.33337H8.66683V1.33337ZM10.0002 2.66671V6.00004H13.3335V2.66671H10.0002ZM1.3335 8.66671H7.3335V14.6667H1.3335V8.66671ZM2.66683 10V13.3334H6.00016V10H2.66683ZM8.66683 8.66671H14.6668V14.6667H8.66683V8.66671ZM10.0002 10V13.3334H13.3335V10H10.0002Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default ViewGridIcon;
